import React from 'react';
import { Link } from 'react-scroll';
import { FaHeart, FaEnvelope, FaPhone, FaTwitter, FaFacebook, FaArrowUp, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', to: 'home' },
    { name: 'About', to: 'about' },
    { name: 'Skills', to: 'skills' },
    { name: 'Portfolio', to: 'portfolio' },
    { name: 'Contact', to: 'contact' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">
              Dhananjay Pandey Bhatni
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed max-w-md">
              Professional astrologer and spiritual guide helping individuals discover their cosmic destiny through ancient wisdom and celestial insights.
            </p>
            <div className="flex space-x-4">
              <a
                href="mailto:dkpandeybhatni@gmail.com"
                className="text-gray-400 hover:text-primary transition-colors duration-300 text-xl"
                aria-label="Email"
              >
                <FaEnvelope />
              </a>
              <a
                href="https://api.whatsapp.com/send/?phone=919838697226&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors duration-300 text-xl"
                aria-label="Whatsapp"
              >
                <FaWhatsapp />
              </a>
              <a
                href="https://www.facebook.com/bhatnipandit?mibextid=ZbWKwL"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors duration-300 text-xl"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/dhananjay.pandey.1441?igsh=N2RseWxrbzQzZzds"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors duration-300 text-xl"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    smooth={true}
                    duration={500}
                    offset={-70}
                    className="text-gray-400 hover:text-primary transition-colors duration-300 cursor-pointer block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">
              Contact
            </h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <FaEnvelope className="text-primary" />
                <span className="text-gray-400 text-sm">dkpandeybhatni@gmail.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <FaPhone className="text-primary" />
                <span className="text-gray-400 text-sm">+91 9838697226</span>
              </div>
              <div className="mt-4">
                <h4 className="text-white font-medium mb-2">Location</h4>
                <p className="text-gray-400 text-sm">NAKSHTRA JYOTISH KENDRA, Nakahni Chauraha - Bhatni Distt. Deoria , U.P</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-4 text-sm text-gray-400">
              <span>&copy; {currentYear} Dhananjay Pandey Bhatni. All rights reserved.</span>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-400">
                <span>Made with</span>
                <FaHeart className="text-primary" />
                <span>and React</span>
              </div>
              
              <button
                onClick={scrollToTop}
                className="bg-primary hover:bg-primary/90 text-white p-2 rounded-full transition-colors duration-300"
                aria-label="Scroll to top"
              >
                <FaArrowUp className="text-sm" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
